module.exports = {"CommonConstants":{"API_URL":"https://psvc.pearsoncmg.com/PearsonAPI","TC_URL":"https://psvc.pearsoncmg.com/PearsonDemo","Base_path":"/PearsonPSVC"},"CommonConstantsLive":{"API_URL":"https://psvc.pearsoncmg.com/PearsonAPI","TC_URL":"https://psvc.pearsoncmg.com/PearsonDemo","Base_path":"/PearsonPSVC"}}


//////////////////
// WEBPACK FOOTER
// ./src/_helpers/config.json
// module id = 44
// module chunks = 2